// GoalGoal.jsx
import React from "react";
import { getGoalGoalOdds } from "../functions";
import { MARKET_BTS, MARKET_BTS_H1 } from "../markets";

const GoalGoal = ({ blocked, odds, goals = [0, 0], period }) => {
  const goalGoalOdds = getGoalGoalOdds(odds, MARKET_BTS) || [];
  const halfTimeGoalGoalOdds = getGoalGoalOdds(odds, MARKET_BTS_H1) || [];

  const [homeGoals, awayGoals] = goals;
  const bothTeamsScored = homeGoals > 0 && awayGoals > 0;

  // Only show HT odds in 1st half (period 1)
  const showHalfTime = period === 1;

  // Hide market if blocked, no odds, or both teams already scored
  if (blocked !== 0 || goalGoalOdds.length === 0 || bothTeamsScored) {
    return <td colSpan="2" />;
  }

  return (
    <>
      {goalGoalOdds.map(({ n, v }, index) => {
        const ft = Number.isFinite(v) ? v.toFixed(2) : "-";
        const htVal = showHalfTime ? halfTimeGoalGoalOdds[index]?.v : null;
        const ht = Number.isFinite(htVal) ? htVal.toFixed(2) : null;

        return (
          <td className="text-center" key={n ?? index}>
            {ft}
            <br />
            {ht && <span className="ht-odds">{ht}</span>}
          </td>
        );
      })}
    </>
  );
};

export default GoalGoal;
